export default {
  downloadBtn: 'download-button',
  selectPngBtn: 'select-png-button',
  selectJpgBtn: 'select-jpg-button',
};
